import { render, staticRenderFns } from "./PalletModify.vue?vue&type=template&id=85038bb2&scoped=true"
import script from "./PalletModify.vue?vue&type=script&lang=js"
export * from "./PalletModify.vue?vue&type=script&lang=js"
import style0 from "./PalletModify.vue?vue&type=style&index=0&id=85038bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85038bb2",
  null
  
)

export default component.exports